//import CmsDatepicker from "./cms-datepicker";

const formConditionalSelector = '.conditional-fields';
const version = '1.0.3';

export default class SystemsightFormConditions {

	static init($context = null){
		console.log('SystemsightFormConditions loaded (' + version + ')');

		let $targets = $context ? $context.find(formConditionalSelector).add($context.filter(formConditionalSelector)) : $(formConditionalSelector);
		$targets.each(function (index, element) {
			if(element.conditional_instance) return;

			element.conditional_instance = new SystemsightFormConditions({}, element);
		});
	}

	/**
	 * @deprecated use init instead
	 */
	static init_conditions(){
		SystemsightFormConditions.init();
	}

	constructor(options, element) {
		let that = this;
		let defaults = {};
		this.options = $.extend(true, {}, defaults, (options || {}));
		this.element = element;
		this.$element = $(element);
		console.log('SystemsightFormConditions('+version+') init for: ', this.element);

		this.$element.find(':input').on('change', function (e) {
			that.checkInputs();

			if(e.currentTarget.dataset.validate === 'onchange'){
				that.validateInputValue(e.currentTarget)
			}

		});

		this.$element.find('[data-toggle="tab"]').on('shown.bs.tab', function (e) {
			that.checkInputs($fieldsGroup);
		});

		this.$element.removeClass('d-none');
		this.checkInputs();
	}

	/**
	 * TODO: padaryti timeout ir timeout clear, nes dabar gali labai uzspaminti requestai
	 * @param input
	 */
	validateInputValue(input){
		if(input.form){
			var relations = null;
			if(input.dataset.validateRelations){
				relations = input.dataset.validateRelations.split(',');
			}

			let $form = $(input.form);
			var formData = $form.serializeArray();
			formData.push(
				{
					name: 'action',
					value: 'validate'
				}
			);
			$.post($form.attr('action'), formData).done(function (r) {

				this.checkInputValidations($(input), r.errors);

				if(relations){
					relations.forEach(function (fieldName) {
						var $input = $form.find('[name="'+fieldName+'"],[name="'+fieldName+'[]"],[data-input_name="'+fieldName+'"]');
						this.checkInputValidations($input, r.errors);
					}.bind(this))
				}
			}.bind(this)).always(function (e) {
			}).fail(function (e) {
			});
		}
	}
	checkInputValidations($input, errors){
		if($input.length === 0) return;

		let inputName = $input[0].name
		if(errors && errors[inputName]){
			console.log(
				errors[inputName]
			);
			$input
				.addClass('is-invalid')
				.parents('.form-group')
				.find('.invalid-feedback')
				.html(
					errors[inputName]
				).addClass('d-block');
		}else{
			$input
				.removeClass('is-invalid is-valid')
				.parents('.form-group')
				.find('.invalid-feedback')
				.html('').removeClass('d-block');
			;
		}
	}

	checkInputs() {
		let that = this;
		let options = this.$element.data('options') || {};

		this.$element.find('.form-group, .form-tab, .conditional-field').each(function (e) {
			var $inputGroup = $(this);
			var conditionals = $(this).data('conditionals');
			if(conditionals){
				var showCondition = true;
				var enableCondition = true;
				conditionals.forEach(conditional => {
					if(typeof conditional.show === 'boolean'){
						var show = conditional.show;
						showCondition = showCondition && (that.getFieldCondition(conditional, show) === show);
					}
					else if(typeof conditional.enable === 'boolean'){
						var enable = conditional.enable;
						enableCondition = enableCondition && (that.getFieldCondition(conditional, enable) === enable);
					}
				});
				that.toggleInput($inputGroup, showCondition, enableCondition);
			}
		});
		if(options.onChecked){
			that.callCallback(options.onChecked);
		}
	};
	getFieldCondition(conditional, show){
		if(typeof conditional.or  === 'object'){
			let orCondition = false;
			conditional.or.forEach(function (conditional) {
				orCondition = orCondition || this.getFieldCondition(conditional, show);
			}.bind(this));
			return orCondition;
		}else if(typeof conditional.when != "undefined"){
			var inputName = conditional.when;
			var $field = this.$element.find(":input[name='"+inputName+"']");
			if($field.attr('type') === "radio"){
				$field = $field.filter(':checked');
			}

			if(this.isFieldValidForConditionals($field)){
				if(conditional.eq !== undefined){
					switch (typeof conditional.eq) {
						case "boolean":
							return $field[0].checked == conditional.eq;
						case "string":
							return $field.val() == conditional.eq;
						case "object":
							return $.inArray($field.val(), conditional.eq) > -1;
					}
				}else if(conditional.gt !== undefined){
					switch (typeof conditional.gt) {
						case "string":
						case "number":
							return $field.val() > conditional.gt;
					}
				}else if(conditional.lt !== undefined){
					switch (typeof conditional.lt) {
						case "string":
						case "number":
							return $field.val() < conditional.lt;
					}
				}else if(conditional.gte !== undefined){
					switch (typeof conditional.gte) {
						case "string":
						case "number":
							return $field.val() >= conditional.gte;
					}
				}else if(conditional.lte !== undefined){
					switch (typeof conditional.lte) {
						case "string":
						case "number":
							return $field.val() <= conditional.lte;
					}
				}
			}else{
				return !show;
			}
		}
		return show;
	}
	isFieldValidForConditionals($field){

		if(!$field.length) return false;

		let fieldType = $field.attr('type');

		if(fieldType && fieldType.toLowerCase() === 'hidden') return true;

		return $field.is(":visible");

	}
	callCallback(callback){
		var that = this;
		if(typeof callback == "string"){
			eval(callback)
		}else{
			callback();
		}
	};
	toggleInput($inputOrGroup, show, enable){
		var that = this;

		if($inputOrGroup.is(':input')){
			if(show){
				$inputOrGroup.attr('disabled', null);

				if(enable){
					$inputOrGroup.attr('disabled', null);
				}else{
					$inputOrGroup.attr('disabled', 'disabled');
				}

			}else{
				$inputOrGroup.attr('disabled', 'disabled');
			}
		}else{
			if(show){
				$inputOrGroup.show();
			}else{
				$inputOrGroup.hide();
			}
			$inputOrGroup.find(':input').each(function () {
				that.toggleInput($(this), show, enable);
			})
		}
	};
}

$(function(){
	//Pridetas velinimas, kad CKEditor laukai butu initializuoti
	setTimeout(function () {
		SystemsightFormConditions.init();
	}, 1000);
});
